module.exports = __webpack_public_path__ + "img/warning.a41f5310.png";